import { type ClassValue, clsx } from 'clsx';

// Utilidad para combinar clases de Tailwind de forma segura
// Nota: Para uso simple, solo usamos clsx
// Si se necesita merge de Tailwind más avanzado, instalar tailwind-merge

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
